import { ButtonInterface } from 'common/types/entities/button-interface'
import React from 'react'
import { ButtonTypeGroup } from 'src/editor/shared/settings/groups/button-type-group'
import { CommonButtonSettings } from '../common-button-settings'

interface LoginButtonSettingsProps {
  entity: ButtonInterface
  defaultEntity?: ButtonInterface
}

export const LoginButtonSettings = ({
  entity,
  defaultEntity,
}: LoginButtonSettingsProps) => {
  return (
    <>
      <ButtonTypeGroup entity={entity} />
      <CommonButtonSettings entity={entity} defaultEntity={defaultEntity} />
    </>
  )
}
